import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-76fbf10b")

_pushScopeId("data-v-76fbf10b")
const _hoisted_1 = { class: "fridgemyassistlistedit-page" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "fridgemyassistlistedit-page-top" }, null, -1)
const _hoisted_3 = { class: "fridgemyassistlistedit-page-contents" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FridgeDetailsMyAssistList = _resolveComponent("FridgeDetailsMyAssistList")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_FridgeDetailsMyAssistList, {
        key: _ctx.updateDisplayKey,
        myAssistList: _ctx.myAssistList,
        isEditMode: _ctx.isEditMode,
        onClickItem: _ctx.clickMyAssistItem,
        onClickDeleteItem: _ctx.clickDeleteMyAssistItem
      }, null, 8, ["myAssistList", "isEditMode", "onClickItem", "onClickDeleteItem"])
    ]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowDialog,
      dialogType: _ctx.dialogType,
      title: _ctx.dialogTitle,
      message: _ctx.dialogMessage,
      positiveLabel: _ctx.dialogPositiveButtonLabel,
      negativeLabel: _ctx.dialogNegativeButtonLabel,
      onPositiveClick: _ctx.dialogPositiveHandler,
      onNegativeClick: _ctx.dialogNegativeHandler,
      onCloseClick: _ctx.dialogCloseHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick", "onCloseClick"])
  ]))
})